import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Redirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/case-studies', { replace: true });
  }, [navigate]);

  return null;
}

export default Redirect;
